(function() {
    'use strict';

    angular
        .module('app')
        .directive('noselect', noselect);

    noselect.$inject = ['$window'];
    
    function noselect ($window) {
        // Usage:
        //     <noselect></noselect>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'EA'
        };
        return directive;

        function link(scope, element, attrs) {
            document.onkeydown = function (e) {
                var keyPressed = e.keyCode;
                if (keyPressed == 16) { //thats the keycode for shift

                    $('html').addClass('noselect'); //noselect contains aforementioned css rules

                    document.onkeyup = function () {
                        $('html').removeClass('noselect'); //and simply remove noselect class making text selection availabe
                    }
                }
            }
        }
    }

})();